






























import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { dateFormate } from '@/utils/report';
const Report = namespace('report');

@Component
export default class DailyDate extends Vue {
  @Prop() private reportId!: number;
  @Prop() private level!: number;
  @Prop() private store_group_id!: number;

  @Report.Mutation('update_export_success') private UPDATE_EXPORT_SUCCESS: any;
  @Report.Getter('exportSuccess') private exportSuccess!: boolean;

  private dialogExportVisible: boolean = false;
  private loading: boolean = false;
  private start: Date | string = new Date();
  get startPickerOptions() {
    return {
      disabledDate: (time: Date) => {
        let curDate = (new Date()).getTime();
        let three = 12 * 30 * 24 * 3600 * 1000;
        let _12Months = curDate - three;
        return time.getTime() >= curDate || time.getTime() <= _12Months;
      }
    }
  };
  public created() {
    const level = this.$route.query.level;
    const start = sessionStorage.getItem("start"); 
    if (start  && level === '1') {
      this.start = start;
      this.$emit('datePass', start);
      // this.$emit('fetchReport');
    }
  }
  public recovery() {
    this.$emit('recovery');
  }
  public exportReport() {
    this.dialogExportVisible = true;
    this.UPDATE_EXPORT_SUCCESS(false);
    this.$emit('exportReport');
  }
  public datePickerChange() {
    sessionStorage.setItem("start", dateFormate(this.start));
    this.$emit('datePass', dateFormate(this.start));
    this.$emit('fetchReport');
  }
}
